import React from 'react';
import styles from './TilesWrapper.styles.scss';
import cn from 'classnames';

const TilesWrapper = ({ children, className }) => {
  return <div className={cn(styles.wrapper, 'row', className)}>{children}</div>;
};

export default React.memo(TilesWrapper);
